<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="1200" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ !formData?.id ? $t('global.menu.backoffice.createCity') : $t('global.menu.backoffice.editCity',
                    { city: formData.name, type: $t(`global.menu.backoffice.${formData.properties?.type}`) }) }}
            </h3>
        </template>

        <template #default>
            <v-tabs class="create-news-tabs" mandatory="true" grow v-model="tab" hide-slider="false"
                selected-class="v-tab-selected" density="compact">
                <v-tab :text="$t('global.form.general')" :value="'general'" variant="text" :ripple="false"
                    size="x-large">

                </v-tab>
                <v-tab :text="$t('global.form.districts')" :value="'districts'" variant="text" :ripple="false"
                    size="x-large">

                </v-tab>
            </v-tabs>
            <v-tabs-window v-model="tab">
                <v-tabs-window-item :value="'general'" class="pa-4">
                    <v-row class="shop-info-container">
                        <!-- Linke Spalte: Basisinformationen -->
                        <v-col cols="12" md="4">
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">{{ $t('global.form.name') }}</v-label>
                                    <v-text-field variant="outlined" v-model="formData.properties.nameDE"
                                        density="compact" :hide-details="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">{{ $t('global.form.name-en') }}</v-label>
                                    <v-text-field variant="outlined" v-model="formData.properties.nameEN"
                                        density="compact" :hide-details="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">{{ $t('global.form.identifier') }}</v-label>
                                    <v-text-field variant="outlined" v-model="formData.identifier" density="compact"
                                        :hide-details="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">URL-Name</v-label>
                                    <v-text-field variant="outlined" v-model="formData.urlName" density="compact"
                                        :hide-details="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">Sortierreihenfolge</v-label>
                                    <v-text-field variant="outlined" v-model="formData.sortOrder" density="compact"
                                        :hide-details="true"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>

                        <!-- Mittlere Spalte: Standort & Social Media -->
                        <v-col cols="12" md="4">
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">Latitude</v-label>
                                    <v-text-field variant="outlined" v-model="formData.location.latitude"
                                        density="compact" :hide-details="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">Longitude</v-label>
                                    <v-text-field variant="outlined" v-model="formData.location.longitude"
                                        density="compact" :hide-details="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">Area Typ</v-label>
                                    <v-select variant="outlined" v-model="formData.properties.type"
                                        :items="['CITY', 'AREA', 'RURAL']" density="compact"
                                        :hide-details="true"></v-select>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">Facebook</v-label>
                                    <v-text-field variant="outlined" v-model="formData.properties.facebookUrl"
                                        density="compact" :hide-details="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">Instagram</v-label>
                                    <v-text-field variant="outlined" v-model="formData.properties.instagramUrl"
                                        density="compact" :hide-details="true"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>

                        <!-- Rechte Spalte: Medien & Events -->
                        <v-col cols="12" md="4">
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">Moin-Post Titel</v-label>
                                    <v-text-field variant="outlined" v-model="formData.properties.initialStreamHeadline"
                                        density="compact" :hide-details="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">Blog URL</v-label>
                                    <v-text-field variant="outlined" v-model="formData.properties.blogUrl"
                                        density="compact" :hide-details="true"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">Shoppingtours & URL</v-label>
                                    <v-text-field variant="outlined" v-model="formData.properties.shoppingTourUrl"
                                        density="compact" :hide-details="true">
                                        <template v-slot:prepend>
                                            <v-checkbox density="compact" v-model="toursEnabledBoolean"
                                                hide-details="true">
                                            </v-checkbox>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                                <v-col>
                                    <v-label class="mr-4">Shop Local Day Programm</v-label>
                                    <v-text-field variant="outlined" v-model="formData.properties.shopLocalDayLink"
                                        density="compact" :hide-details="true">
                                        <template v-slot:prepend>
                                            <v-checkbox density="compact"
                                                v-model="shopLocalDayProgrammeAvailableBoolean" hide-details="true">
                                            </v-checkbox>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center" dense>
                                <v-col>
                                    <v-checkbox density="compact" v-model="eventsEnabledBoolean" hide-details="true">
                                        <template v-slot:label>
                                            <v-label class="mr-4">Events aktiviert</v-label>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row justify="center" align="center" dense>
                                <v-col>
                                    <v-checkbox density="compact" v-model="shopLocalDayEnabledBoolean"
                                        hide-details="true">
                                        <template v-slot:label>
                                            <v-label class="mr-4">Shop Local Day aktiviert</v-label>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                            </v-row>

                        </v-col>
                        <!-- {{ formData }} -->
                    </v-row>
                </v-tabs-window-item>
                <v-tabs-window-item :value="'districts'" class="pa-4">
                    <v-row>
                        <v-col cols="12">
                            <v-table density="compact" dense>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            {{ $t('global.form.district') }}
                                        </th>
                                        <th class="text-left">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><v-text-field variant="outlined" v-model="newDistrict.name"
                                                density="compact" :hide-details="true"></v-text-field></td>
                                        <td>
                                            <v-btn variant="flat" class="text-right" color="primary" size="small"
                                                @click="() => createDistrict()">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <!-- {{ formData?.districts }} -->
                                    <tr v-for="item in formData?.districts" :key="item.name">
                                        <td>{{ item.name }}</td>
                                        <td>
                                            <v-btn variant="flat" class="text-right" color="error" size="small"
                                                @click="deleteDistrict(item.id)">
                                                <v-icon>mdi-trash-can-outline</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-table>
                        </v-col>
                    </v-row>
                </v-tabs-window-item>
            </v-tabs-window>

        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="save">{{ $t('global.form.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "CreateCityDialog",
    components: {
    },


    methods: {
    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';

const softToken = localStorage.getItem("softToken");
const hardToken = localStorage.getItem("hardToken");
const username = localStorage.getItem("username");
const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({ properties: {}, location: {} }) }); // Handles v-model for the object
const tab = ref('general');
const newDistrict = ref({ name: '', id: null })
defineProps({
    save: Function, // Define prop as a function
});
const { proxy } = getCurrentInstance();

const fetchDistricts = inject("fetchDistricts")

const createDistrict = async () => {
    const obj = { ...newDistrict.value }
    try {
        const response = await proxy.$axios.post(`/backoffice/cities/${formData.value.id}/districts`, obj, {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });

        if (response.data.status == "OK") {
            fetchDistricts(formData.value);
        }
    } catch (error) {
        console.error("Error fetching search results:", error);
    } finally {
        newDistrict.value = { name: '', id: null };
    }
    // /api/backoffice/cities/803bfb5f-461a-4806-938d-eaef82f293bd/districts POST {name: null}
}
const deleteDistrict = async (id) => {
    try {
        const response = await proxy.$axios.delete(`/backoffice/districts/${id}`, {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });

        if (response.data.status == "OK") {
            fetchDistricts(formData.value);
        }

    } catch (error) {
        console.error("Error fetching search results:", error);
    }

    // DELETE /api/backoffice/districts/f8016a04-923d-498d-bf04-939f272e70c5
}

watch(
    () => formData.value?.properties?.nameDE, // Safely watch nameDE
    (newValue) => {
        if (newValue !== undefined) {
            formData.value.name = newValue; // Update name
        }
    }
);
watch(formData, (newValue) => {
    if (!newValue) {
        formData.value = { properties: {}, location: {} };
    }
});
watch(dialogVisible, (newValue) => {
    if (!newValue) {
        formData.value = { properties: {}, location: {} };
        tab.value = 'general';
    }
});

const eventsEnabledBoolean = computed({
    get: () => formData.value.properties?.eventsEnabled === "true", // Safely check
    set: (val) => {
        if (formData.value.properties) { // Ensure properties exist before setting value
            formData.value.properties.eventsEnabled = val ? "true" : "false";
        }
    },
});
const toursEnabledBoolean = computed({
    get: () => formData.value.properties?.toursEnabled === "true", // Safely check
    set: (val) => {
        if (formData.value.properties) { // Ensure properties exist before setting value
            formData.value.properties.toursEnabled = val ? "true" : "false";
        }
    },
});
const shopLocalDayEnabledBoolean = computed({
    get: () => formData.value.properties?.shopLocalDayEnabled === "true", // Safely check
    set: (val) => {
        if (formData.value.properties) { // Ensure properties exist before setting value
            formData.value.properties.shopLocalDayEnabled = val ? "true" : "false";
        }
    },
});
const shopLocalDayProgrammeAvailableBoolean = computed({
    get: () => formData.value.properties?.shopLocalDayProgrammeAvailable === "true", // Safely check
    set: (val) => {
        if (formData.value.properties) { // Ensure properties exist before setting value
            formData.value.properties.shopLocalDayProgrammeAvailable = val ? "true" : "false";
        }
    },
});

const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = { properties: {}, location: {} };
}
onMounted(() => {

});
</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label,
.v-col>.v-checkbox .v-label {
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}
</style>
